<template>
  <v-avatar color="green lighten-4">
    <v-img v-if="resolvedSrc" :src="resolvedSrc" />
    <span v-if="name && !resolvedSrc">{{ (name || "...").substr(0, 1) }}</span>
    <span v-if="current && !resolvedSrc">{{
      (user && user.name ? user.name : "...").substr(0, 1)
    }}</span>
  </v-avatar>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "EUserAvatar",
  props: {
    current: {
      type: Boolean,
      default: true,
    },
    src: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    resolvedSrc() {
      const apiHost = (process.env.VUE_APP_API_HOST || "").replace(/\/$/, "");
      const token = localStorage.getItem("access_token") || "";
      const tokenParam = token ? `?token=${token}` : "";
      if (this.src) {
        if (
          this.src.startsWith("http://") ||
          this.src.startsWith("https://") ||
          this.src.startsWith("/")
        ) {
          return this.src;
        }
        return `${apiHost}/recursos-humanos/foto/${this.src}${tokenParam}`;
      }
      const rh = this.user?.recursos_humanos || this.user?.recursosHumanos;
      if (this.current && this.user && rh && rh.foto) {
        return `${apiHost}/recursos-humanos/foto/${rh.foto}${tokenParam}`;
      }
      return null;
    },
  },
};
</script>
